const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}} st>Yash Tripathi</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">
<br/>
{<ul className="pra-det">
<li>I'm Yash Tripathi, Pre-Final Year Student persuing Btech in Computer Science.</li>
<li>Photography Head, UPES-CSI </li>
<li>Member of the organizing committee for multiple hackathons.</li>
</ul>}
</div>
</div>
</>
 }

 export default data;